// src/menu-items/ozeki.jsx
const OzekiInbox = {
  id: "group-ozeki",
  title: "Ozeki",
  type: "group",
  children: [
    {
      id: "ozeki-inbox",
      title: "Inbox",
      type: "item",
      url: "/ozeki-inbox",
      icon: "ph ph-inbox"
    }
  ]
};

export default OzekiInbox;
